var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"camera-page-shoot-contents-check"},[_c('div',{staticClass:"checking-gauge"}),_c('div',{staticClass:"checking-text"},[_c('div',{staticClass:"checking-text-check"},[_vm._v(_vm._s(_vm.$t('202305_011')))]),_c('div',{staticClass:"checking-text-wait"},[_vm._v(_vm._s(_vm.$t('202305_0115')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }